import PropTypes from 'prop-types';
import { useContext, useEffect } from 'react';
import { axiosInstanceNew } from 'src/utils/axios';
import { pricesUpdated } from 'src/redux/slices/prices-slice';
import { clientDispatch } from 'src/redux/clientStore';
import { AuthContext } from 'src/auth/context';

export default function ClientBootstrap({ children }) {
  const { loading } = useContext(AuthContext);

  useEffect(() => {
    if (loading) return;

    const fetchPrices = async () => {
      try {
        const response = await axiosInstanceNew('/tokens/token-prices');
        const { prices: tokenPrices } = response.data;
        clientDispatch(pricesUpdated(tokenPrices));
      } catch (error) {
        console.error('Failed to fetch token prices', error);
      }
    };

    fetchPrices();
  }, [loading]);

  return children;
}

ClientBootstrap.propTypes = {
  children: PropTypes.node,
};
